/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Legacy_Admin_Unit_HintInputs */

const vi_customer_legacy_admin_unit_hint = /** @type {(inputs: Customer_Legacy_Admin_Unit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chưa chuẩn hoá`)
};

/**

* @param {Customer_Legacy_Admin_Unit_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_legacy_admin_unit_hint = /** @type {((inputs?: Customer_Legacy_Admin_Unit_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Legacy_Admin_Unit_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_legacy_admin_unit_hint(inputs)
});